import { CellTypeNames } from './CellTypeConstants';

type TranslationFunction = (translationKey: string, defaultValue: string) => string;

export const getCellTypeTranslationKey = (cellTypeName: CellTypeNames): string => {
    const keyMap: Record<CellTypeNames, string> = {
        [CellTypeNames.AUTO]: 'auto',
        [CellTypeNames.NUMBER]: 'number',
        [CellTypeNames.CURRENCY]: 'currency',
        [CellTypeNames.PERCENTAGE]: 'percentage',
        [CellTypeNames.TEXT]: 'text',
        [CellTypeNames.DATE_TIME]: 'dateTime',
        [CellTypeNames.CHECKBOX]: 'checkbox',
    };
    return keyMap[cellTypeName] || 'auto';
};

export const translateCellType = (cellTypeName: CellTypeNames, translate: TranslationFunction): string => {
    const key = getCellTypeTranslationKey(cellTypeName);
    // Provide fallback display names
    const fallbacks: Record<CellTypeNames, string> = {
        [CellTypeNames.AUTO]: 'Auto',
        [CellTypeNames.NUMBER]: 'Number',
        [CellTypeNames.CURRENCY]: 'Currency',
        [CellTypeNames.PERCENTAGE]: 'Percentage',
        [CellTypeNames.TEXT]: 'Text',
        [CellTypeNames.DATE_TIME]: 'Date & Time',
        [CellTypeNames.CHECKBOX]: 'Checkbox',
    };
    return translate(`cellType.${key}`, fallbacks[cellTypeName]);
};
